import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowDownLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconArrowDownLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M18.4571 5.54289C18.8476 5.93342 18.8476 6.56658 18.4571 6.95711L8.41421 17H15C15.5523 17 16 17.4477 16 18C16 18.5523 15.5523 19 15 19H6C5.44772 19 5 18.5523 5 18V9C5 8.44772 5.44772 8 6 8C6.55228 8 7 8.44772 7 9V15.5858L17.0429 5.54289C17.4334 5.15237 18.0666 5.15237 18.4571 5.54289Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowDownLeft;
